import React, { useState, useEffect, useRef } from 'react'
import * as d3 from 'd3';
import { useQuery } from '@apollo/client';
import { GET_ONE_FEDERAL_POPULATION_PYRAMID,
    GET_ONE_FEDERAL_POPULATION_PYRAMID_PROVINCE,
    GET_ONE_FEDERAL_POPULATION_PYRAMID_CANADA } from '../../../../apollo/queries'
import { doProvince } from '../../../../helpers/Utils';
import ReactGA from 'react-ga';

const PopulationPyramid = (props) => {

    var country_id = 'canada';
    var prov = doProvince(props.ld);

    const [pyramidData, setPyramidData] = useState(null);
    const [pyramidDataProvince, setPyramidDataProvince] = useState(null);
    const [pyramidDataCanada, setPyramidDataCanada] = useState(null);
    const [pyramidDataType, setPyramidDataType] = useState('riding');

    const { loading1, error1, data1 } = useQuery(GET_ONE_FEDERAL_POPULATION_PYRAMID, {onCompleted: setPyramidData,
        variables: { local_division:String(props.ld) }
    });

    const { loading6, error6, data6 } = useQuery(GET_ONE_FEDERAL_POPULATION_PYRAMID_PROVINCE, {onCompleted: setPyramidDataProvince,
        variables: { province_id:String(props.ld).substr(0,2) }
    });

    const { loading7, error7, data7 } = useQuery(GET_ONE_FEDERAL_POPULATION_PYRAMID_CANADA, {onCompleted: setPyramidDataCanada,
        variables: { country:country_id }
    });  

    var jsondata, percentage, totalPopulation, tooltipDiv, xScale, yScale, maxValue, width, sectorWidth, leftBegin, rightBegin, yAxisLeft, yAxisRight, xAxisRight, xAxisLeft, pyramid, legend;
    var height = 500;

    var margin = {
        top: 50,
        right: 10,
        bottom: 50,
        left: 10,
        middle: 20
    };
    
    var style = {
        leftBarColor: '#6c9dc6',
        rightBarColor: '#de5454',
        tooltipBG: '#fefefe',
        tooltipColor: 'black'
    };

    const parentgraph = useRef(null);
    const d3Container = useRef(null);
    const [theWidth, setTheWidth] = useState(0);
    const [theMode, setTheMode] = useState('riding');

    tooltipDiv = d3.select("body").append("div")
    .attr("class", "tooltip")
    .style("opacity", 0);

    const updateBars = (a) => {
        var thedata;
        if (a === 'province') {
            setTheMode('province');
            thedata = pyramidDataProvince.getFederalPopulationProvince;
            ReactGA.event({
                category: "Population Graph",
                action: "click",
                label: "province "+props.ld,
            });
        } else if (a === 'canada') {
            setTheMode('canada');
            thedata = pyramidDataCanada.getFederalPopulationCanada;
            ReactGA.event({
                category: "Population Graph",
                action: "click",
                label: "canada "+props.ld,
            });            
        } else {
            setTheMode('riding');
            thedata = pyramidData.getFederalPopulation;
            ReactGA.event({
                category: "Population Graph",
                action: "click",
                label: "riding "+props.ld,
            });
        }

        height = 500 - (margin.top + margin.bottom);

        percentage = function(d) {
            return d / totalPopulation;
        };

        totalPopulation = d3.sum(thedata, function(d) {
            return d.male + d.female;
        });

        maxValue = Math.ceil(Math.max(
            d3.max(thedata, function(d) {
                return percentage(d.male);
            }),
            d3.max(thedata, function(d) {
                return percentage(d.female);
            })
        )/0.05)*0.05;

        sectorWidth = ((parentgraph.current.offsetWidth  - (margin.left + margin.right)) / 2) - margin.middle;
        leftBegin = sectorWidth;
        rightBegin = (parentgraph.current.offsetWidth  - (margin.left + margin.right)) - sectorWidth;
        xScale = d3.scaleLinear().range([0, (((parentgraph.current.offsetWidth - (margin.left + margin.right))/2) - margin.middle)]).domain([0, maxValue]).nice();
        xAxisRight = d3.axisBottom().scale(xScale).tickFormat(d3.format('.1%'));
        xAxisLeft = d3.axisBottom().scale(xScale.copy().range([leftBegin, 0])).tickFormat(d3.format('.1%'));
        yScale = d3.scaleBand().domain(thedata.map(function(d) { return d.age })).range([height, 0], 0.1)
        yAxisLeft = d3.axisRight().scale(yScale).tickSize(4, 0).tickPadding(margin.middle - 4);
        yAxisRight = d3.axisLeft().scale(yScale).tickSize(4, 0).tickFormat('');     

        if ((parentgraph.current.offsetWidth  - (margin.left + margin.right)) < 240) {
            xAxisRight = d3.axisBottom().scale(xScale).tickFormat(d3.format('.1%')).ticks(3);
            xAxisLeft = d3.axisBottom().scale(xScale.copy().range([leftBegin, 0])).tickFormat(d3.format('.1%')).ticks(3);
        } else if ((parentgraph.current.offsetWidth  - (margin.left + margin.right)) < 450) {
            xAxisRight = d3.axisBottom().scale(xScale).tickFormat(d3.format('.1%')).ticks(5);
            xAxisLeft = d3.axisBottom().scale(xScale.copy().range([leftBegin, 0])).tickFormat(d3.format('.1%')).ticks(5);
        } else {
            xAxisRight = d3.axisBottom().scale(xScale).tickFormat(d3.format('.1%'));
            xAxisLeft = d3.axisBottom().scale(xScale.copy().range([leftBegin, 0])).tickFormat(d3.format('.1%'));    
        }            

        d3
            .selectAll('.bar.left')
            .data(thedata)
            .attr('transform', translation(leftBegin, 0) + 'scale(-1,1)')
            .on("mouseover", function(event, d) {
                tooltipDiv.transition()
                        .duration(200)
                        .style("opacity", 0.9);
                tooltipDiv.html("<strong>Males Age " + d.age + "</strong>" +
                                "<br />  Population: " + prettyFormat(d.male) +
                                "<br />" + (percentage(d.male)*100).toFixed(2) + "% of Total")
                        .style("left", (event.pageX) + "px")
                        .style("top", (event.pageY - 28) + "px");
            })
            .on("mouseout", function(d) {
                tooltipDiv.transition()
                        .duration(500)
                        .style("opacity", 0);
            })
            .transition()
            .duration(1000)      
            .attr('y', function(d) {
                return yScale(d.age) + margin.middle / 4;
            })
            .attr('width', function(d) {
                return xScale(percentage(d.male));
            })
            .attr('height', (yScale.range()[0] / thedata.length) - margin.middle / 2)

        d3
            .selectAll('.bar.right')
            .data(thedata)
            .on("mouseover", function(event, d) {
                tooltipDiv.transition()
                          .duration(200)
                          .style("opacity", 0.9);
                tooltipDiv.html("<strong>Females Age " + d.age + "</strong>" +
                                "<br />  Population: " + prettyFormat(d.female) +
                                "<br />" + (percentage(d.female)*100).toFixed(2) + "% of Total")
                        .style("left", (event.pageX) + "px")
                        .style("top", (event.pageY - 28) + "px");
            })
            .on("mouseout", function(d) {
                tooltipDiv.transition()
                          .duration(500)
                          .style("opacity", 0);
            })
            .transition()
            .duration(1000)        
            .attr('transform', translation(rightBegin, 0))
            .attr('class', 'bar right')
            .attr('x', 0)
            .attr('y', function(d) {
                return yScale(d.age) + margin.middle / 4;
            })
            .attr('width', function(d) {
                return xScale(percentage(d.female));
            })
            .attr('height', (yScale.range()[0] / thedata.length) - margin.middle / 2)

        d3
            .select("#xaxisleft")
            .transition()
            .duration(1000)        
            .call(xAxisLeft)

        d3
            .select("#xaxisright")
            .transition()
            .duration(1000)        
            .call(xAxisRight)        

    }

    const translation = (x, y) => {
        return 'translate(' + x + ',' + y + ')';
    }

    const prettyFormat = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const colorTransform = (c1, c2) => {
        var c1 = c1.replace('#',''),
            origHex = {
                r: c1.substring(0, 2),
                g: c1.substring(2, 4),
                b: c1.substring(4, 6)
            },
            transVec = {
                r: c2.substring(0, 2),
                g: c2.substring(2, 4),
                b: c2.substring(4, 6)
            },
            newHex = {};

        function transform(d, e) {
            var f = parseInt(d, 16) + parseInt(e, 16);
            if (f > 255) {
                f = 255;
            }
            return f.toString(16);
        }
        newHex.r = transform(origHex.r, transVec.r);
        newHex.g = transform(origHex.g, transVec.g);
        newHex.b = transform(origHex.b, transVec.b);
        return '#' + newHex.r + newHex.g + newHex.b;
    }

    useEffect(
        () => {
            var svg = null;
            if (pyramidData !== null && pyramidDataProvince !== null && pyramidDataCanada !== null && prov !== null && props.ld !== null && d3Container.current) {
                if (theMode === 'riding') {
                    jsondata = pyramidData.getFederalPopulation;
                } else if (theMode === 'province') {
                    jsondata = pyramidDataProvince.getFederalPopulationProvince;
                } else {
                    jsondata = pyramidDataCanada.getFederalPopulationCanada;
                }

                window.addEventListener("resize", handleResize);
                handleResize();

                function handleResize() {
                    setTheWidth(parentgraph.current.offsetWidth  - (margin.left + margin.right));

                    sectorWidth = ((parentgraph.current.offsetWidth  - (margin.left + margin.right)) / 2) - margin.middle;
                    leftBegin = sectorWidth;
                    rightBegin = (parentgraph.current.offsetWidth  - (margin.left + margin.right)) - sectorWidth;
                    xScale = d3.scaleLinear().range([0, (((parentgraph.current.offsetWidth - (margin.left + margin.right))/2) - margin.middle)]).domain([0, maxValue]);
                    
                    if ((parentgraph.current.offsetWidth  - (margin.left + margin.right)) < 240) {
                        xAxisRight = d3.axisBottom().scale(xScale).tickFormat(d3.format('.1%')).ticks(3);
                        xAxisLeft = d3.axisBottom().scale(xScale.copy().range([leftBegin, 0])).tickFormat(d3.format('.1%')).ticks(3);
                    } else if ((parentgraph.current.offsetWidth  - (margin.left + margin.right)) < 450) {
                        xAxisRight = d3.axisBottom().scale(xScale).tickFormat(d3.format('.1%')).ticks(5);
                        xAxisLeft = d3.axisBottom().scale(xScale.copy().range([leftBegin, 0])).tickFormat(d3.format('.1%')).ticks(5);
                    } else {
                        xAxisRight = d3.axisBottom().scale(xScale).tickFormat(d3.format('.1%'));
                        xAxisLeft = d3.axisBottom().scale(xScale.copy().range([leftBegin, 0])).tickFormat(d3.format('.1%'));    
                    }

                    var totalPopulation = d3.sum(jsondata, function(d) {
                        return d.male + d.female;
                    });

                    var percentage = function(d) {
                        return d / totalPopulation;
                    };

                    try {
                        if (document.getElementById("xaxisleft") !== null) {
                            document.getElementById("xaxisleft").remove();
                            document.getElementById("xaxisright").remove();
                            document.getElementById("yaxisleft").remove();
                            document.getElementById("yaxisright").remove();
                            document.getElementById("barleft").remove();                                
                            document.getElementById("barright").remove();                                                                
                            // pyramid.selectAll(".bar.left").remove();
                            // pyramid.selectAll(".bar.right").remove();
                            document.getElementById("pyramidlegend").remove();
                        }
                        if (pyramid !== undefined) { 
                            pyramid.append('g')
                                .attr('id', 'xaxisleft')
                                .attr('class', 'axis x left')
                                .attr('transform', translation(0, height))
                                .call(xAxisLeft);
                    
                            pyramid.append('g')
                                .attr('id', 'xaxisright')
                                .attr('class', 'axis x right')
                                .attr('transform', translation(rightBegin, height))
                                .call(xAxisRight);

                            pyramid.append('g')
                                .attr('id', 'yaxisleft')
                                .attr('class', 'axis y left')
                                .attr('transform', translation(leftBegin, 0))
                                .call(yAxisLeft)
                                .selectAll('text')
                                .style('text-anchor', 'middle');
                        
                            pyramid.append('g')
                                .attr('id', 'yaxisright')
                                .attr('class', 'axis y right')
                                .attr('transform', translation(rightBegin, 0))
                                .call(yAxisRight);                                  

                            pyramid.append('g')
                                .attr('id', 'barleft')
                                .selectAll('.bar.left')
                                .data(jsondata)
                                .enter().append('rect')
                                .attr('class', 'bar left')
                                .attr('transform', translation(leftBegin, 0) + 'scale(-1,1)')
                                .attr('x', 0)
                                .attr('y', function(d) {
                                    return yScale(d.age) + margin.middle / 4;
                                })
                                .attr('width', function(d) {
                                    return xScale(percentage(d.male));
                                })
                                .attr('height', (yScale.range()[0] / jsondata.length) - margin.middle / 2)
                                .on("mouseover", function(event, d) {
                                    tooltipDiv.transition()
                                        .duration(200)
                                        .style("opacity", 0.9);
                                    tooltipDiv.html("<strong>Males Age " + d.age + "</strong>" +
                                            "<br />  Population: " + prettyFormat(d.male) +
                                            "<br />" + (percentage(d.male)*100).toFixed(2) + "% of Total")
                                        .style("left", (event.pageX) + "px")
                                        .style("top", (event.pageY - 28) + "px");
                                })
                                .on("mouseout", function(d) {
                                    tooltipDiv.transition()
                                        .duration(500)
                                        .style("opacity", 0);
                                });
                        
                            pyramid.append('g')
                                .attr('id', 'barright')
                                .selectAll('.bar.right')
                                .data(jsondata)
                                .enter().append('rect')
                                .attr('transform', translation(rightBegin, 0))
                                .attr('class', 'bar right')
                                .attr('x', 0)
                                .attr('y', function(d) {
                                    return yScale(d.age) + margin.middle / 4;
                                })
                                .attr('width', function(d) {
                                    return xScale(percentage(d.female));
                                })
                                .attr('height', (yScale.range()[0] / jsondata.length) - margin.middle / 2)
                                .on("mouseover", function(event, d) {
                                    tooltipDiv.transition()
                                        .duration(200)
                                        .style("opacity", 0.9);
                                    tooltipDiv.html("<strong> Females Age " + d.age + "</strong>" +
                                            "<br />  Population: " + prettyFormat(d.female) +
                                            "<br />" + (percentage(d.female)*100).toFixed(2) + "% of Total")
                                        .style("left", (event.pageX) + "px")
                                        .style("top", (event.pageY - 28) + "px");
                                })
                                .on("mouseout", function(d) {
                                    tooltipDiv.transition()
                                        .duration(500)
                                        .style("opacity", 0);
                                });      
                        }                              

                        if (legend !== undefined) {
                            legend = svg.append('g')
                                .attr('id','pyramidlegend')
                                .attr('class', 'legend');
                        
                            legend.append('rect')
                                .attr('id','pyramidlegendbarleft')
                                .attr('class', 'bar left')
                                .attr('x', ((parentgraph.current.offsetWidth  - (margin.left + margin.right)) / 2) - (margin.middle * 3))
                                .attr('y', 12)
                                .attr('width', 12)
                                .attr('height', 12);
                        
                            legend.append('text')
                                .attr('id','pyramidlegendbarlefttext')
                                .attr('fill', 'currentColor')
                                .attr('x', ((parentgraph.current.offsetWidth  - (margin.left + margin.right)) / 2) - (margin.middle * 2))
                                .attr('y', 18)
                                .attr('dy', '0.32em')
                                .text('Males');
                        
                            legend.append('rect')
                                .attr('id','pyramidlegendbarright')
                                .attr('class', 'bar right')
                                .attr('x', ((parentgraph.current.offsetWidth  - (margin.left + margin.right)) / 2) + (margin.middle * 2))
                                .attr('y', 12)
                                .attr('width', 12)
                                .attr('height', 12);
                        
                            legend.append('text')
                                .attr('id','pyramidlegendbarrighttext')
                                .attr('fill', 'currentColor')
                                .attr('x', ((parentgraph.current.offsetWidth  - (margin.left + margin.right)) / 2) + (margin.middle * 3))
                                .attr('y', 18)
                                .attr('dy', '0.32em')
                                .text('Females');
                        }


                    } catch (err) {
                        console.log(err);
                    }
                }

                width = parentgraph.current.offsetWidth - (margin.left + margin.right);

                sectorWidth = (width / 2) - margin.middle;
                leftBegin = sectorWidth;
                rightBegin = width - sectorWidth;                    

                svg = d3.select(d3Container.current);
                svg.attr("width",svg.attr('width'));
                const height = svg.attr("height") - (margin.top + margin.bottom);

                d3.select(d3Container.current).append('style')
                    .text(`
                        svg {
                            max-width:100%
                        }
                        .axis line, axis path {
                            shape-rendering: crispEdges;
                            fill: transparent;
                            stroke: #555;
                        }
                        .axis text {
                            font-size: 8px;
                        }
                        .bar {
                            fill-opacity: 0.5;
                        }
                        .bar.left {
                            fill: ${style.leftBarColor};
                        }
                        .bar.left:hover {
                            fill: ${colorTransform(style.leftBarColor, '333333')};
                        }
                        .bar.right {
                            fill: ${style.rightBarColor};
                        }
                        .bar.right:hover {
                            fill: ${colorTransform(style.rightBarColor, '333333')};
                        }
                        .tooltip {
                            position: absolute;
                            line-height: 1.1em;
                            padding: 7px; 
                            margin: 3px;
                            background: ${style.tooltipBG}; 
                            color: ${style.tooltipColor}; 
                            pointer-events: none;
                            border-radius: 6px;
                        }
                        `);


                var totalPopulation = d3.sum(jsondata, function(d) {
                    return d.male + d.female;
                });

                var percentage = function(d) {
                    return d / totalPopulation;
                };

                var maxValue = Math.ceil(Math.max(
                    d3.max(jsondata, function(d) {
                        return percentage(d.male);
                    }),
                    d3.max(jsondata, function(d) {
                        return percentage(d.female);
                    })
                )/0.05)*0.05;

                setTheWidth(parentgraph.current.offsetWidth  - (margin.left + margin.right));
                var xScale = d3.scaleLinear().domain([0, maxValue]).range([0, sectorWidth]).nice();
                var yScale = d3.scaleBand().domain(jsondata.map(function(d) { return d.age })).range([height, 0], 0.1)
                var yAxisLeft = d3.axisRight().scale(yScale).tickSize(4, 0).tickPadding(margin.middle - 4);
                var yAxisRight = d3.axisLeft().scale(yScale).tickSize(4, 0).tickFormat('');
                var xAxisRight = d3.axisBottom().scale(xScale).tickFormat(d3.format('.1%'));
                var xAxisLeft = d3.axisBottom().scale(xScale.copy().range([leftBegin, 0])).tickFormat(d3.format('.1%'));

                if ((parentgraph.current.offsetWidth  - (margin.left + margin.right)) < 240) {
                    xAxisRight = d3.axisBottom().scale(xScale).tickFormat(d3.format('.1%')).ticks(3);
                    xAxisLeft = d3.axisBottom().scale(xScale.copy().range([leftBegin, 0])).tickFormat(d3.format('.1%')).ticks(3);
                } else if ((parentgraph.current.offsetWidth  - (margin.left + margin.right)) < 450) {
                    xAxisRight = d3.axisBottom().scale(xScale).tickFormat(d3.format('.1%')).ticks(5);
                    xAxisLeft = d3.axisBottom().scale(xScale.copy().range([leftBegin, 0])).tickFormat(d3.format('.1%')).ticks(5);
                } else {
                    xAxisRight = d3.axisBottom().scale(xScale).tickFormat(d3.format('.1%'));
                    xAxisLeft = d3.axisBottom().scale(xScale.copy().range([leftBegin, 0])).tickFormat(d3.format('.1%'));    
                }                        

                pyramid = svg.append('g')
                    .attr('class', 'inner-region')
                    .attr('transform', translation(margin.left, margin.top));


                legend = svg.append('g')
                    .attr('id','pyramidlegend')
                    .attr('class', 'legend');
            
                legend.append('rect')
                    .attr('id','pyramidlegendbarleft')
                    .attr('class', 'bar left')
                    .attr('x', (width / 2) - (margin.middle * 3))
                    .attr('y', 12)
                    .attr('width', 12)
                    .attr('height', 12);
            
                legend.append('text')
                    .attr('id','pyramidlegendbarlefttext')
                    .attr('fill', 'currentColor')
                    .attr('x', (width / 2) - (margin.middle * 2))
                    .attr('y', 18)
                    .attr('dy', '0.32em')
                    .text('Males');
            
                legend.append('rect')
                    .attr('id','pyramidlegendbarright')
                    .attr('class', 'bar right')
                    .attr('x', (width / 2) + (margin.middle * 2))
                    .attr('y', 12)
                    .attr('width', 12)
                    .attr('height', 12);
            
                legend.append('text')
                    .attr('id','pyramidlegendbarrighttext')
                    .attr('fill', 'currentColor')
                    .attr('x', (width / 2) + (margin.middle * 3))
                    .attr('y', 18)
                    .attr('dy', '0.32em')
                    .text('Females');
                
                pyramid.append('g')
                    .attr('id', 'yaxisleft')
                    .attr('class', 'axis y left')
                    .attr('transform', translation(leftBegin, 0))
                    .call(yAxisLeft)
                    .selectAll('text')
                    .style('text-anchor', 'middle');
            
                pyramid.append('g')
                    .attr('id', 'yaxisright')
                    .attr('class', 'axis y right')
                    .attr('transform', translation(rightBegin, 0))
                    .call(yAxisRight);
            
                pyramid.append('g')
                    .attr('id', 'xaxisleft')
                    .attr('class', 'axis x left')
                    .attr('transform', translation(0, height))
                    .call(xAxisLeft);
            
                pyramid.append('g')
                    .attr('id', 'xaxisright')
                    .attr('class', 'axis x right')
                    .attr('transform', translation(rightBegin, height))
                    .call(xAxisRight);

                pyramid.append('g')
                    .attr('id', 'barleft')
                    .selectAll('.bar.left')
                    .data(jsondata)
                    .enter().append('rect')
                    .attr('transform', translation(leftBegin, 0) + 'scale(-1,1)')
                    .attr('class', 'bar left')
                    .attr('x', 0)
                    .attr('y', function(d) {
                        return yScale(d.age) + margin.middle / 4;
                    })
                    .attr('width', function(d) {
                        return xScale(percentage(d.male));
                    })
                    .attr('height', (yScale.range()[0] / jsondata.length) - margin.middle / 2)
                    .on("mouseover", function(event, d) {
                        tooltipDiv.transition()
                            .duration(200)
                            .style("opacity", 0.9);
                        tooltipDiv.html("<strong>Males Age " + d.age + "</strong>" +
                                "<br />  Population: " + prettyFormat(d.male) +
                                "<br />" + (percentage(d.male)*100).toFixed(2) + "% of Total")
                            .style("left", (event.pageX) + "px")
                            .style("top", (event.pageY - 28) + "px");
                    })
                    .on("mouseout", function(d) {
                        tooltipDiv.transition()
                            .duration(500)
                            .style("opacity", 0);
                    });
            
                pyramid.append('g')
                    .attr('id', 'barright')
                    .selectAll('.bar.right')
                    .data(jsondata)
                    .enter().append('rect')
                    .attr('transform', translation(rightBegin, 0))
                    .attr('class', 'bar right')
                    .attr('x', 0)
                    .attr('y', function(d) {
                        return yScale(d.age) + margin.middle / 4;
                    })
                    .attr('width', function(d) {
                        return xScale(percentage(d.female));
                    })
                    .attr('height', (yScale.range()[0] / jsondata.length) - margin.middle / 2)
                    .on("mouseover", function(event, d) {
                        tooltipDiv.transition()
                            .duration(200)
                            .style("opacity", 0.9);
                        tooltipDiv.html("<strong> Females Age " + d.age + "</strong>" +
                                "<br />  Population: " + prettyFormat(d.female) +
                                "<br />" + (percentage(d.female)*100).toFixed(2) + "% of Total")
                            .style("left", (event.pageX) + "px")
                            .style("top", (event.pageY - 28) + "px");
                    })
                    .on("mouseout", function(d) {
                        tooltipDiv.transition()
                            .duration(500)
                            .style("opacity", 0);
                    });
                    
                    
                    return () => window.removeEventListener("resize", handleResize);
    
            }                    
                
        },[parentgraph, d3Container, pyramidData, pyramidDataProvince, pyramidDataCanada])

    return (
        <div>
        {theMode === "riding" ? <button style={{marginRight:'5px'}} className="btn btn-sm btn-outline-primary active" onClick={() => updateBars('riding')}>This Riding</button> : <button style={{marginRight:'5px'}} className="btn btn-sm btn-outline-primary" onClick={() => updateBars('riding')}>This Riding</button> } 
        {theMode === "province" ? <button style={{marginRight:'5px'}} className="btn btn-sm btn-outline-primary active" onClick={() => updateBars('province')}>Province ({prov})</button> : <button style={{marginRight:'5px'}} className="btn btn-sm btn-outline-primary" onClick={() => updateBars('province')}>Province ({prov})</button> } 
        {theMode === "canada" ? <button className="btn btn-sm btn-outline-primary active" onClick={() => updateBars('canada')}>Canada</button> : <button className="btn btn-sm btn-outline-primary" onClick={() => updateBars('canada')}>Canada</button> }
        <div ref={parentgraph} style={{width:'auto', display: 'flex', flexDirection: 'column'}}>
        <svg
            className="d3-component"
            height={500}
            width={theWidth+margin.middle}
            viewBox={`0 0 ${theWidth+margin.middle} 500`}
            ref={d3Container}
        />
        </div></div>
    )
  }
  
  export default PopulationPyramid;